import { ca } from '@cian/analytics';
import { EFrequency } from '@cian/save-search-widget';

export interface ITrackSubscribedParameters {
  jsonQuery: unknown;
  frequency: EFrequency;
  subscribeToNews: boolean;
  subscribeToPushAvailable: boolean;
  subscribeToPush: boolean;
}

const notificationFrequencyMap: { [key in EFrequency]: string } = {
  [EFrequency.Asap]: 'Asap',
  [EFrequency.Hourly]: 'Hourly',
  [EFrequency.Daily]: 'Daily',
  [EFrequency.Weekly]: 'Weekly',
};

export function trackSubscribed({
  jsonQuery,
  frequency,
  subscribeToNews,
  subscribeToPushAvailable,
  subscribeToPush,
}: ITrackSubscribedParameters): void {
  let label = 'From_cat_save';

  label += `/${notificationFrequencyMap[frequency]}`;

  if (subscribeToPushAvailable) {
    const pushOnOff = subscribeToPush ? 'PushOn' : 'PushOff';

    label += `/${pushOnOff}`;
  }

  ca('eventSite', {
    action: 'Send',
    category: 'subscription',
    label,
    name: 'oldevent',
    pageType: 'Listing',
  });

  if (subscribeToNews) {
    ca('eventSite', {
      action: 'Send',
      category: 'subscription',
      label: 'news',
      name: 'oldevent',
      pageType: 'Listing',
      sc: jsonQuery,
    });
  }
}
